/* eslint-enable */
/* eslint-enable */

class AnimationGridArbitraryContentMobileGallery {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleGridArbitraryContentMobileGallery = this.sectionsContainer.querySelectorAll('.grid-arbitrary-mobile-gallery');
		
		if (!this.$moduleGridArbitraryContentMobileGallery.length)
			return;
		
		this.$moduleGridArbitraryContentMobileGalleryElements = [];

		this.$moduleGridArbitraryContentMobileGallery.forEach(module => {
			this.$moduleGridArbitraryContentMobileGalleryElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleGridArbitraryContentMobileGallery.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleGridArbitraryContentMobileGalleryElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleGridArbitraryContentMobileGallery = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleGridArbitraryContentMobileGallery[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleGridArbitraryContentMobileGalleryElements[index], { clearProps: true });
			}
        });
    
        this.moduleGridArbitraryContentMobileGallery.addLabel('step1');
        this.moduleGridArbitraryContentMobileGallery.to(this.$moduleGridArbitraryContentMobileGallery[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleGridArbitraryContentMobileGallery.to(this.$moduleGridArbitraryContentMobileGalleryElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationGridArbitraryContentMobileGallery;
